export enum HttpCodes {
  OK = 200,
  CREATED = 201,
  ACCEPTED = 202,
  NO_CONTENT = 204,
  MULTI_STATUS = 207,
  NOT_FOUND = 404,
  FORCE_RELOGIN = 419,
  UNATHORIZED = 401,
  MAINTENANCE = 503,
  TIMEOUT = 504,
  SERVER_ERROR = 500,
}
